
import './Footer.css'

function Footer() {
    return (

        <footer className="footer">
            <strong className='copy mt-5'>Fran López Laperal  &copy;</strong>
        </footer>

    )
}

export default Footer